"use client";

import { MemoryBankDialog } from "@/components/memory-bank-dialog";
import { User } from "next-auth";
import { ReactNode, createContext, useContext, useState } from "react";

interface MemoryDialogContextType {
    openMemoryDialog: () => void;
    closeMemoryDialog: () => void;
}

const MemoryDialogContext = createContext<MemoryDialogContextType | undefined>(
    undefined,
);

export function useMemoryDialog() {
    const context = useContext(MemoryDialogContext);
    if (context === undefined) {
        throw new Error(
            "useMemoryDialog must be used within a MemoryDialogProvider",
        );
    }
    return context;
}

interface MemoryDialogProviderProps {
    children: ReactNode;
    user: User | undefined;
}

export function MemoryDialogProvider({
    children,
    user,
}: MemoryDialogProviderProps) {
    const [memoryDialogOpen, setMemoryDialogOpen] = useState(false);

    const openMemoryDialog = () => {
        setMemoryDialogOpen(true);
    };

    const closeMemoryDialog = () => {
        setMemoryDialogOpen(false);
    };

    return (
        <MemoryDialogContext.Provider
            value={{ openMemoryDialog, closeMemoryDialog }}
        >
            {children}
            {user && (
                <MemoryBankDialog
                    open={memoryDialogOpen}
                    onOpenChange={setMemoryDialogOpen}
                    patientId={user.id || ""}
                />
            )}
        </MemoryDialogContext.Provider>
    );
}
